import { HAN_MILES_PER_HAN } from "@-/dev.improve.haniverse.lib.han-currency";

export type TravelErrorCode =
  | "already-here"
  | "already-placed"
  | "in-transit"
  | "insufficient-han"
  | "locked"
  | "no-dragon"
  | "no-han-miles-discount"
  | "not-in-transit"
  | "not-visited"
  | "unplaced"
  | "unknown-option";

const MESSAGES: Record<TravelErrorCode, string> = {
  "already-here": "You are already here.",
  "already-placed": "You have already chosen where to start.",
  "in-transit": "You are still travelling.",
  "insufficient-han": "Not enough Han for this fare.",
  locked: "Learn this place's name before travelling there.",
  "no-dragon": "You have no dragon to ride.",
  "no-han-miles-discount": `HanMiles only take Han off flights, ¥1 per ${HAN_MILES_PER_HAN}.`,
  "not-in-transit": "There is no journey to cancel.",
  "not-visited": "You can only teleport to places you have visited.",
  "unknown-option": "That route is no longer available.",
  unplaced: "Choose a starting place first.",
};

export class TravelError extends Error {
  readonly code: TravelErrorCode;

  constructor(code: TravelErrorCode) {
    super(MESSAGES[code]);
    this.code = code;
    this.name = "TravelError";
  }
}
